var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("taskList.taskFlow"),
                                prop: "taskType",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  clearable: true,
                                  options: {
                                    LINE_SOURCING: "按线路报价价格确认流程",
                                    QUOTATION: "供应商报价",
                                    PRODUCT_SOURCING: "按产品报价价格确认流程",
                                    STORE_FEEDBACK: "质量反馈",
                                    PROBLEM_REPORT_HANDLE: "问题报告处理",
                                    MSV: "MSV审核",
                                    SUPPLIER_REG: "潜在供应商",
                                    SUPPLIER_REG_MDM: "潜在供应商MDM",
                                    SUPPLIER_UPDATE: "供应商资源管理",
                                    FPA_PERMANENT: "FPA_PERMANENT",
                                    FPA_LTO_CAMPAIGN: "FPA_LTO_CAMPAIGN",
                                    FPA_LTO: "FPA_LTO",
                                    BC: "BC",
                                    GRI: "GRI",
                                    CAPACITY: "产能调查",
                                    UNIT_OF_ACCOUNT: "结算单位",
                                    LAW_FILE: "法务文件",
                                    MATERIAL: "物料审核",
                                    DC: "DC审核",
                                  },
                                },
                                model: {
                                  value: _vm.queryCondition.taskType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "taskType",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.taskType",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("taskList.bizNo"),
                                prop: "bizNo",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.queryCondition["bizNo"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "bizNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "queryCondition['bizNo']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "创建日期(从)",
                                prop: "dateFrom",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  "picker-options": _vm.pickerOptionsStart,
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.queryCondition.dateFrom,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "dateFrom",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.dateFrom",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "创建日期(至)", prop: "dateTo" },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  "picker-options": _vm.pickerOptionsEnd,
                                  type: "date",
                                  placeholder: _vm.$t("common.selDate"),
                                },
                                model: {
                                  value: _vm.queryCondition.dateTo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "dateTo", $$v)
                                  },
                                  expression: "queryCondition.dateTo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.TaskListTransfer,
                      expression: "TaskListTransfer",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.openTransferDialog },
                },
                [_vm._v("转移任务")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": "530",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.changeSelect },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  selectable: (row) => row.status != "FINISH",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "taskTypeName",
                  label: _vm.$t("taskList.taskFlow"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "bizNo",
                  label: _vm.$t("taskList.bizNo"),
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            staticClass: "el-link",
                            on: {
                              click: function ($event) {
                                return _vm.view(
                                  scope.row.taskType,
                                  scope.row.bizId,
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.bizNo))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "createDate",
                  label: _vm.$t("common.TaskCreationTime"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("dateFormatFilter")(
                              scope.row.createDate,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "status",
                  label: _vm.$t("common.status"),
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("common.operation") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.MyTaskImg,
                                expression: "MyTaskImg",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.changeImg(scope.row.piId)
                              },
                            },
                          },
                          [_vm._v("img")]
                        ),
                        scope.row.status != "FINISH"
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "acl",
                                    rawName: "v-acl",
                                    value: _vm.finish_task,
                                    expression: "finish_task",
                                  },
                                ],
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delTask(
                                      scope.row.piId,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("结束工作流")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 15, 50, 100],
                  "page-size": _vm.queryCondition.pageSize,
                  "current-page": _vm.queryCondition.pageNum,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { title: "流程进度", visible: _vm.imgDialog, width: "600px" },
          on: {
            close: function ($event) {
              _vm.imgDialog = false
            },
          },
        },
        [_c("img", { attrs: { src: _vm.src } })]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: { visible: _vm.auditDialog, width: "1200px" },
          on: {
            close: function ($event) {
              _vm.auditDialog = false
            },
          },
        },
        [_c("router-view")],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "任务转移",
            visible: _vm.transferDialog,
            width: "600px",
          },
          on: {
            close: function ($event) {
              _vm.transferDialog = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "transferForm",
              attrs: {
                model: _vm.transferForm,
                rules: _vm.transferFormRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "转移到", prop: "transferToUserIds" } },
                [
                  _vm.hackReset
                    ? _c("pickupUser", {
                        ref: "pickupUser",
                        attrs: { multi: "", title: "选择人员" },
                        on: { change: _vm.changeTransferTo },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.transfer()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.transferDialog = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }